import { useState, forwardRef } from 'react'
import { useCombobox } from 'downshift'
import { useTheme } from 'styled-components'

// Components
import Input from '../input'

const Autocomplete = forwardRef(
  (
    {
      id,
      label,
      className,
      inputClassName,
      onChange,
      children,
      search,
      selectedItem,
      color,
      ...rest
    },
    ref
  ) => {
    const [options, setOptions] = useState([])
    const theme = useTheme();
    const onSearch = async (inputValue) => {
      const results = await search(inputValue)
      setOptions(results || [])
    }

    const [inputValue, setInputValue] = useState(selectedItem?.selected || '')

    const {
      isOpen,
      getLabelProps,
      getMenuProps,
      highlightedIndex,
      getItemProps,
      getInputProps,
      getComboboxProps,
      openMenu,
    } = useCombobox({
      id,
      items: options,
      itemToString: (item) => item?.selected || '',
      inputValue,
      initialSelectedItem: selectedItem,
      selectedItem: selectedItem || null,
      onSelectedItemChange: ({ selectedItem: nextSelectedItem }) => {
        setInputValue(nextSelectedItem?.selected || '')
        onChange(nextSelectedItem)
      },
      onIsOpenChange: ({
        selectedItem: nextSelectedItem,
        isOpen: nextIsOpen,
      }) => {
        if (!nextIsOpen) {
          setInputValue(
            nextSelectedItem?.selected || selectedItem?.selected || ''
          )

          if (!selectedItem) {
            setOptions([])
          }
        }
      },
      onInputValueChange: ({ inputValue: nextInputValue }) => {
        setInputValue(nextInputValue)
        onSearch(nextInputValue)
      },
    })

    return (
      <div
        {...getComboboxProps({ ref })}
        className="ul-relative ul-w-full"
      >
        <Input
          {...rest}
          {...getInputProps({
            id,
            onClick: () => {
              openMenu()
            },
            onFocus: (e) => {
              e.target.select()
              // set ring color when focus the input
              e.target.parentElement.style.boxShadow = `var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) ${theme.mainColor}`
            },
            onBlur: (e) => {
              // remove ring color onBlur
              e.target.parentElement.style.boxShadow = "none"
            }
          })}
          label={label}
          labelProps={getLabelProps()}
          className={className}
          inputClassName={inputClassName}
          style={{ color: theme.mainColor }}
        />
        <div {...getMenuProps()} className="ul-relative ul-z-20">
          {isOpen
            ? children({
                items: options.map((option, index) => ({
                  ...option,
                  getItemProps: (props) =>
                    getItemProps({ item: option, index, ...props }),
                })),
                highlightedIndex,
              })
            : null}
        </div>
      </div>
    )
  }
)

export default Autocomplete
